


import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { RegistorUser } from "../CommonAPI/Common";
import { Link, useNavigate } from "react-router-dom";

// Note: Assuming 'newlogin-...' classes are defined in your CSS

const RegistrationForm = () => {
    const navigate = useNavigate();
    const [signupData, setSignupData] = useState({
        username: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [signupShowPassword, setSignupShowPassword] = useState({
        password: false,
        confirmPassword: false,
    });
    
    // Naya state: Premium/Standard view ko control karne ke liye
    // Hum isse hardcode 'right-panel-active' ki tarah use karenge
    const [isStandardView, setIsStandardView] = useState(true); // Default: Registration form dikhega

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSignupData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleRegistor = async (e) => {
        if (e) e.preventDefault();

        if (!/^\d{10}$/.test(signupData.phone)) {
            Swal.fire({
                backdrop: "#121010ba",
                confirmButtonColor: "#1ccc8a",
                title: "Error!",
                text: "Phone number must be exactly 10 digits!",
                icon: "error",
                timer: 2000,
                timerProgressBar: true,
            });
            return;
        }

        // if (signupData.password !== signupData.confirmPassword) {
        //     Swal.fire({
        //         backdrop: "#121010ba",
        //         confirmButtonColor: "#1ccc8a",
        //         title: "Error!",
        //         text: "Password and Confirm Password must be the same!",
        //         icon: "error",
        //         timer: 2000,
        //         timerProgressBar: true,
        //     });
        //     return;
        // }

        const data = {
            SignuserName: signupData.username,
            mobile_no: signupData.phone,
            SignEmail: signupData.email,
            // Signpassword: signupData.password,
            // ConfirmPassword: signupData.confirmPassword,
        };

        await RegistorUser(data)
            .then((response) => {
                if (response.Status) {
                    toast.success(response.message, {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "dark",
                        onClose: () => {
                            setSignupData({
                                username: "",
                                phone: "",
                                email: "",
                                password: "",
                                confirmPassword: "",
                            });
                            // Registration successful hone par login page par redirect karein
                            navigate('/login');
                        }
                    });
                } else {
                    return Swal.fire({
                        backdrop: "#121010ba",
                        confirmButtonColor: "#1ccc8a",
                        title: "Error!",
                        text: response.message,
                        icon: "error",
                        timer: 2000,
                        timerProgressBar: true,
                    });
                }
            })
            .catch((err) => {
                console.log("Error in adding the new user", err);
                Swal.fire({
                    backdrop: "#121010ba",
                    confirmButtonColor: "#1ccc8a",
                    title: "Network Error!",
                    text: "Could not connect to the server.",
                    icon: "error",
                    timer: 2500,
                    timerProgressBar: true,
                });
            });
    };

    return (
        <section className="premium-auth-page">
              <div className="animated-bg-elements">
        {/* These div elements are styled and animated by the CSS below */}
        <div className="bg-bar bar-1"></div>
        <div className="bg-bar bar-2"></div>
        <div className="bg-bar bar-3"></div>
        <div className="bg-bar bar-4"></div>
        <div className="bg-bar bar-5"></div>
        <div className="bg-bar bar-6"></div>
        <div className="bg-bar bar-7"></div>
      </div>
             <div className="premium-auth-container">
                   {/* Logo Section - Uses the same dark theme header as Login */}
                <div className="premium-logo-header">
                    <img
                      alt="logo"
                        // Aap yahan actual logo source set karein
                        src={localStorage.getItem("logo")} 
                        style={{ width: "160px", height: "auto" }}
                    />
                </div>

                {/* Form Card */}
                <div className="premium-form-card">
                    <h1 className="premium-title">Open Your Trading Account</h1>
                    <p className="premium-subtitle">Join us to start automated, intelligent trading.</p>
                    
                    <form className="premium-form" onSubmit={handleRegistor}>
                        
                        {/* Username and Phone Inputs */}
                        <div className="premium-input-group-half">
                            <input
                                type="text"
                                name="username"
                                autoComplete="username"
                                placeholder="Username"
                                className="premium-input"
                                value={signupData.username}
                                onChange={(e) => setSignupData({ ...signupData, username: e.target.value })}
                                required
                            />
                            <input
                                type="text"
                                name="phone"
                                autoComplete="tel"
                                placeholder="Phone Number (10 digits)"
                                className="premium-input"
                                value={signupData.phone}
                                onChange={(e) => setSignupData({ ...signupData, phone: e.target.value })}
                                required
                                maxLength={10}
                            />
                        </div>
                        
                        {/* Email Input */}
                        <input
                            type="email"
                            name="email"
                            autoComplete="email"
                            placeholder="Email"
                            className="premium-input"
                            value={signupData.email}
                            onChange={(e) => setSignupData({ ...signupData, email: e.target.value })}
                            required
                        />
                        
                        {/* Password and Confirm Password Inputs with Toggles */}
                        {/* <div className="premium-input-group-half"> */}
                            {/* Password */}
                            {/* <div className="premium-input-wrapper">
                                <input
                                    type={signupShowPassword.password ? "text" : "password"}
                                    name="password"
                                    autoComplete="new-password"
                                    placeholder="Password"
                                    className="premium-input"
                                    value={signupData.password}
                                    onChange={(e) => setSignupData({ ...signupData, password: e.target.value })}
                                    required
                                />
                                <span className="premium-password-toggle" onClick={() => setSignupShowPassword((s) => ({ ...s, password: !s.password }))}>
                                    {signupShowPassword.password ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div> */}
                            
                            {/* Confirm Password */}
                            {/* <div className="premium-input-wrapper">
                                <input
                                    type={signupShowPassword.confirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    autoComplete="new-password"
                                    placeholder="Confirm Password"
                                    className="premium-input"
                                    value={signupData.confirmPassword}
                                    onChange={(e) => setSignupData({ ...signupData, confirmPassword: e.target.value })}
                                    required
                                />
                                <span className="premium-password-toggle" onClick={() => setSignupShowPassword((s) => ({ ...s, confirmPassword: !s.confirmPassword }))}>
                                    {signupShowPassword.confirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div> */}
                        {/* </div> */}
                        
                        <button type="submit" className="premium-button primary-action-btn">
                            Create Account
                        </button>
                    </form>

                    <p className="premium-switch-text">
                        Already a member?
                        <Link to="/login" className="premium-switch-link"> Sign In</Link>
                        {/* <button 
                            type="button"
                            className="premium-switch-link"
                            onClick={onNavigateToLogin}
                        >
                            Sign In
                        </button> */}
                    </p>
                </div>
            </div>
            <ToastContainer />
        </section>
    );
};

export default RegistrationForm;